import api from './api';

// 댓글 관련 API 호출 함수들
export const commentApi = {
  // 댓글 조회
  getComments: async (articleType, articleId, sortBy, { optionalAuth = false, ...config } = {}) => {
    const response = await (optionalAuth ? api.getAuth : api.getPublic)(
      `/comments/${articleType}/${articleId}?sortBy=${sortBy || 'likes'}`,
      config,
    );
    return response.data;
  },

  // 코멘트 수정
  updateComment: async (commentId, content, config = {}) => {
    const response = await api.putAuth(`/comments/${commentId}`, { content }, config);
    return response.data;
  },

  // 코멘트 삭제
  deleteComment: async (commentId, config = {}) => {
    const response = await api.deleteAuth(`/comments/${commentId}`, config);
    return response.data;
  },

  // 좋아요 추가
  addLike: async (commentId, config = {}) => {
    const response = await api.postAuth(
      '/likes',
      {
        itemType: 'COMMENT',
        itemId: Number(commentId),
      },
      config,
    );
    return response.data;
  },

  // 좋아요 삭제
  deleteLike: async (commentId, config = {}) => {
    const response = await api.deleteAuth(`/likes/comment/${commentId}`, config);
    return response.data;
  },

  // 댓글 ID로 해당 리뷰의 페이지 정보 조회
  getCommentPageInfo: async (commentId) => {
    const response = await api.getPublic(`/comments/${commentId}/review-page`);
    return response.data;
  },
};
